<template>
  <div class="block block-fx-shadow block-rounded">
    <div class="block-header block-header-default">
      <h3 class="block-title">{{ $t('users.activities') }}</h3>
    </div>
    <div class="table-responsive">
      <table class="table table-borderless table-striped table-hover">
        <thead>
          <tr>
            <th>#</th>
            <th>Событие</th>
            <th>Ip-адрес</th>
            <th>Дата и время</th>
          </tr>
        </thead>
        <tbody>
          <template v-if="!isProcessing">
            <tr v-for="(activity, index) in adminUserActivities" :key="index">
              <td>{{++index}}</td>
              <td>{{activity.action}}</td>
              <td>{{activity.ip_address}}</td>
              <td>{{activity.created_at | datetimeFormat}}</td>
              <td>
                <span v-if="activity.data.country">
                  <strong>Страна: </strong>{{activity.data.country}}
                </span>
                <span v-if="activity.data.city">
                  <br><strong>Город: </strong>{{activity.data.city}}
                </span>
              </td>
            </tr>
          </template>
          <tr v-if="isProcessing">
            <td colspan="3" class="text-center">
              <loader-wave/>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      users: [],
      isProcessing: false,
    };
  },
  computed: {
    ...mapGetters([
      'adminUserActivities',
    ]),
  },
  mounted() {
    this.GET_ADMIN_USER_ACTIVITIES(this.$route.params.id);
  },
  methods: {
    ...mapActions([
      'GET_ADMIN_USER_ACTIVITIES',
    ]),
  },
};
</script>
